import { render, staticRenderFns } from "./AgendaDetails.vue?vue&type=template&id=ecbd3152&"
import script from "./AgendaDetails.vue?vue&type=script&lang=ts&"
export * from "./AgendaDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports